<template>
  <div class="filter-item">
    <div class="md-layout">
      <div class="md-layout-item">
        <md-field>
          <label>Поиск</label>
          <md-input class="md-layout-item"  v-bind:value="searchText()"
                    v-on:input="searchText($event)"  v-on:keyup.enter="searchCashChange" md-dense ></md-input>
        </md-field>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchFilter',
  data () {
    return {
      value: null
    }
  },
  methods: {
    searchCashChange () {
      this.$emit('changeCashFilter')
    },
    searchText (cl) {
      if (typeof (cl) !== 'undefined') {
        this.$store.state.filtersCash.q = cl
      }
      return this.$store.state.filtersCash.q
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/filters/cashbox/search.vue